class AttachmentStyle {
  static responsiveStyle(attachmentObj: any) {
    return {
      'background-attachment': `${attachmentObj} !important`
    }
  }
}

export default AttachmentStyle